<template>
  <SearchCombobox
    placeholder="Адрес"
    data-qa="laboratories-list-content-search"
    @search:text="searchLabList"
    @search:default="resetSearch"
  />
</template>

<script lang="ts" setup>
import SearchCombobox from 'www/vue_components/common/core/SearchCombobox/SearchCombobox.vue'
import { MAX_SEARCH_LENGTH } from 'www/vue_components/common/Analyses/constants'
import useLabsStore from 'www/vue_components/common/Analyses/components/LaboratoriesList/stores/useLabsStore'

const labsStore = useLabsStore()
const {
  resetLabPaginator,
  updateRequestLabData,
  resetLabList,
  requestLabListSearch,
} = labsStore

async function resetSearch() {
  updateRequestLabData({ searchString: '' })
  resetLabPaginator()
  await resetLabList()
}

async function searchLabList(searchString: string) {
  if (searchString === '') {
    await resetSearch()
  }

  if (searchString.length > MAX_SEARCH_LENGTH) {
    return
  }

  updateRequestLabData({ searchString })
  await requestLabListSearch()
}
</script>
